export { default } from '@framework/tenant/config/dealroadshow';
